module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t8"
  }, [_vm._v("By")]), _vm._v(" X"), _c('span', {
    staticClass: "t9"
  }, [_vm._v("AVIER")]), _vm._v(" M"), _c('span', {
    staticClass: "t9"
  }, [_vm._v("AYNE")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t8"
  }, [_vm._v("The Accidental Cupid")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t8"
  }, [_vm._v("Husband Material")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("A B")]), _c('span', {
    staticClass: "t11"
  }, [_vm._v("RANDT")]), _vm._v(" "), _c('span', {
    staticClass: "t11"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "t10"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "t11"
  }, [_vm._v("ONNELLY")]), _vm._v(" "), _c('span', {
    staticClass: "t10"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "t11"
  }, [_vm._v("APER")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t8"
  }, [_vm._v("Frat House Troopers")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t8"
  }, [_vm._v("Wrestling Demons")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t8"
  }, [_vm._v("A Wedding to Die For")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t8"
  }, [_vm._v("Spring Break at the Villa Hermes")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t8"
  }, [_vm._v("Published by")]), _vm._v(" D"), _c('span', {
    staticClass: "t9"
  }, [_vm._v("REAMSPINNER")]), _vm._v(" P"), _c('span', {
    staticClass: "t9"
  }, [_vm._v("RESS")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t8"
  }, [_vm._v("http://www.dreamspinnerpress.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47a756e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/003.vue
// module id = 60
// module chunks = 0